<template>
  <div v-if="order && formater">
    <v-sheet class="hidden-print" style="margin-top: 80px" />
    <OnePiecePrint
      :formater="formater"
      :data="order"
      dataFormaterKey="shop.print_order_template.template"
    />
  </div>
</template>
<script>
import Orders from "@/api/orders";
import PrintTemplates from "@/api/print_templates";
import OnePiecePrint from "@/components/plugins/print/OnePiecePrint";

export default {
  components: {
    OnePiecePrint,
  },

  data: () => ({
    formater: null,
    order: {},
  }),

  mounted() {
    PrintTemplates.fetchOne("order").then(
      function (response) {
        if (response.data.status.isOK()) {
          var formater = response.data.print_template.template;
          this.formater = formater;

          //获取单据详情
          Orders.orderPrint(this.$route.params.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.order = response.data.order;
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
  },
};
</script>